module.exports = __webpack_public_path__ + "img/special.c8a6b325.svg";